import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import MaintenanceEntryPage from 'src/components/maintenance/MaintenanceEntryPage';
import { MAINTENANCE_ANCHORS } from 'src/constants/maintenance';
import FeaturesContext from 'src/context/FeaturesContext';
import {
  usePostProcessor,
  usePostProcessorType,
} from 'src/hooks/services/usePostProcessor';
import useQueryParams from 'src/hooks/useQueryParams';
import { FEATURES, isFeatureEnabled } from 'src/utils/features';
import userPropType from 'src/utils/user-prop-type';

const anchor = MAINTENANCE_ANCHORS.post_processor;

/**
 * Post-processor maintenance entry page — resolves the post-processor + its
 * type through the post-processor resource hooks and defers the loading /
 * not-found gates and the operator flow to the shared MaintenanceEntryPage.
 */
const PostProcessorMaintenancePage = ({ user }) => {
  const { uuid } = useParams();
  const { event: initialEventUuid } = useQueryParams();
  const { features } = useContext(FeaturesContext);
  const isEnabled = isFeatureEnabled(features, FEATURES.EQUIPMENT_MAINTENANCE);

  const instanceQuery = usePostProcessor(uuid, { enabled: isEnabled });
  const typeUri = instanceQuery.data?.[anchor.typeUriField];
  const typeQuery = usePostProcessorType(typeUri, { enabled: isEnabled && Boolean(typeUri) });

  return (
    <MaintenanceEntryPage
      user={user}
      uuid={uuid}
      anchor={anchor}
      isEnabled={isEnabled}
      instanceQuery={instanceQuery}
      typeQuery={typeQuery}
      initialEventUuid={initialEventUuid}
    />
  );
};

PostProcessorMaintenancePage.propTypes = {
  user: userPropType,
};

PostProcessorMaintenancePage.defaultProps = {
  user: null,
};

export default PostProcessorMaintenancePage;
